import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import html2canvas from 'html2canvas'

export default function Result() {
  const { oid, code } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const answers = location.state?.answers || []
  const formData = location.state?.formData || {}
  const [data, setData] = useState([])
  const resultRef = useRef(null)

  useEffect(() => {
    axios.post('/c/assessment/submit', {
      code: code,
      merchant_oid: oid,
      answers: answers,
      name: formData.name || '',
      id_number: formData.idNumber || '',
      phone: formData.phone || '',
      college: formData.college || '',
      major: formData.major || ''
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setData(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oid, code])

  const handleShare = async () => {
    const element = resultRef.current
    if (!element) return

    try {
      const canvas = await html2canvas(element, {
        useCORS: true,
        scale: 2, // 提高清晰度
        backgroundColor: '#ffffff'
      })

      const imgData = canvas.toDataURL('image/png')

      // 跳转到新页面并传图片
      navigate(`/${oid}/share/${code}`, { state: { preview: imgData } })
    } catch (err) {
      console.error('生成图片失败：', err)
    }
  }

  return (
    <div className='result-page'>
      <div ref={resultRef}>
        <img className='result-bg' src='/images/result-bg.png' alt="" />
        <div className='result-top'>
          <div className='result-title'>{data.assessment_name}</div>
          <div className='result-name'>受测人：{formData.name || '匿名'}</div>
          <div className='result-time'>报告生成时间：{data.create_time}</div>
        </div>

        <div className='result-content'>
          <span>您的测评结果为：</span>
          <h2>{data.result}</h2>
          <p>{data.interpretation}</p>
        </div>
      </div>

      <div className='result-button' onClick={handleShare}>分享测评报告</div>
    </div>
  )
}
